<template>
  <li class="dropdown-menu--header" :tabindex="null" :aria-disabled="true">
    <span class="title">{{ title }}</span>
    <slot />
  </li>
</template>
<script>
export default {
  componentName: 'WootDropdownMenu',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown-menu--header {
  list-style: none;

  .title {
    width: 100%;
    display: block;
    text-align: left;
    white-space: nowrap;
    padding: var(--space-one) var(--space-two);
    line-height: var(--space-two);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-small);
    color: var(--conversa2-neutral-800-color);
  }
}
</style>
